import { Button, Flex, parseColor, Text, Z_INDEX } from '@talos/kyoko';
import styled from 'styled-components';

export const MouseEventCapture = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${Z_INDEX.popover};
`;

export const SelectedMarketsWrapper = styled(Flex)`
  z-index: ${Z_INDEX.popover - 1};
`;
SelectedMarketsWrapper.defaultProps = {
  display: 'flex',
  position: 'absolute',
  alignItems: 'center',
  right: 'spacing12',
  top: 'spacing12',
};

export const MarketTag = styled(Flex)`
  flex: 1 0 auto;
  background: ${({ theme }) => theme.colors.gray['010']};
  border-radius: 3px;
  height: 24px;
  padding: ${({ theme }) => `${theme.spacing4}px ${theme.spacing8}px`};
  align-items: center;
  gap: ${({ theme }) => theme.spacing4}px;

  ${Text} {
    line-height: 1;
  }
`;

export const AddMarketButton = styled(Button)<{ background?: string }>`
  ${({ background, theme }) => background && `background: ${parseColor(theme, background)};`};

  &:hover {
    ${({ background, theme }) => background && `background: ${parseColor(theme, background)};`};
  }
`;
